import React, { useCallback, useMemo } from 'react';
import I18n from 'i18n-js';
import { Popover } from 'grab-ui';
import QRCodeContainer from 'components/v2/qrcode-container';
import useLocale from 'components/v2/common/hooks/use-locale';
import HelpCenter from 'public/icons/help-center.svg';
import { getHelpCenterOnelink } from 'helper/deeplink';
import _get from 'lodash/get';
import { HELP_CENTER } from 'constants/app-constants';
import { useSelector } from 'react-redux';
import { getUserCountryCodeFromState } from 'selectors/app-selector';
import styles from './contact-help-center.less';

const ContactHelperCenterIcon = () => {
  const locale = useLocale();
  const countryCode = useSelector(getUserCountryCodeFromState);
  const helpCenterLink = HELP_CENTER[countryCode] || HELP_CENTER.SG;

  const { helpCenterTitle, helpCenterHtml } = useMemo(() => {
    const html = I18n.t(
      'phrase.common.express_anytime_booking_body_visit_help_centre_column',
    );
    const div = document.createElement('div');
    div.innerHTML = html;
    const aTag = div.getElementsByTagName('a');
    const helpCenterTitle = _get(aTag, '0.innerHTML') || '';
    return { helpCenterTitle, helpCenterHtml: html };
  }, []);

  const contentClickHandler = useCallback(
    e => {
      const targetLink = e.target && e.target.closest('a');
      if (!targetLink) return;
      window.open(helpCenterLink, '_blank');
    },
    [helpCenterLink],
  );

  return (
    <Popover
      trigger={'hover'}
      placement={'top'}
      content={
        <div className={styles.popOverContainer}>
          {helpCenterTitle && <h4>{helpCenterTitle}</h4>}
          <QRCodeContainer
            content={getHelpCenterOnelink(locale, countryCode)}
            qrCodeClickable
          >
            <div
              className={styles.description}
              onClick={contentClickHandler}
              // eslint-disable-next-line
              dangerouslySetInnerHTML={{
                __html: helpCenterHtml,
              }}
            />
          </QRCodeContainer>
        </div>
      }
      overlayClassName={styles.buttonPopover}
    >
      <img
        src={HelpCenter}
        className={styles.button}
        alt="Contact Help Center Button"
      />
    </Popover>
  );
};

export default ContactHelperCenterIcon;
